import React from 'react';

import {
  createGenerateClassName,
  StylesProvider as MuiStylesProvider,
} from '@material-ui/styles';
import { StylesProviderProps } from '@material-ui/styles/StylesProvider';

import { jssPluginsAlpha, jssPluginsBudapest } from '../style';

interface FdStylesProviderProps extends StylesProviderProps {
  namespace: string;
}

const generateClassName = (namespace) => {
  const namePrefix = namespace === 'fd-budapest' ? 'budapest' : namespace;

  return createGenerateClassName({
    productionPrefix: namePrefix,
  });
};

const getJssPlugins = (namespace) =>
  namespace === 'fd-budapest' ? jssPluginsBudapest : jssPluginsAlpha;

export const StylesProvider = (props: FdStylesProviderProps): JSX.Element => (
  <MuiStylesProvider
    generateClassName={generateClassName(props.namespace)}
    jss={getJssPlugins(props.namespace)}
  >
    {props.children}
  </MuiStylesProvider>
);
